import React from "react";
import { Button, CardActions, Grid } from "@mui/material";
import PropType from "prop-types";
import { parseHtml } from "../../utils/utils";
import AwardCard from "../cards/slide-up-cards/award-card";

AchievementsSection.propTypes = {
    achievements: PropType.array.isRequired
};

function AchievementsSection({ achievements }) {
    return (
        <div
            style={{
                padding: 10
            }}
        >
            <div className="container">
                <h2 style={{ marginBottom: 30 }}>Achievements</h2>
                <Grid container spacing={3} justifyContent="left" alignItems="start" className="mb-5">
                    {achievements.map((award, index) => (
                        <Grid item xs={12} md={6} lg={4} key={index}>
                            <AwardCard
                                imageUrl={award.imageUrl}
                                title={award.title}
                                subtitle={award.secondaryDescription}
                                content={parseHtml(award.description)}
                                customComponent={
                                    award.buttonLink && (
                                        <CardActions className="award-actions">
                                            <Button
                                                variant="outlined"
                                                size="small"
                                                onClick={() => {
                                                    window.open(award.buttonLink, "_blank");
                                                }}
                                            >
                                                {award.buttonText}
                                            </Button>
                                        </CardActions>
                                    )
                                }
                            />
                        </Grid>
                    ))}
                </Grid>
            </div>
        </div>
    );
}

export default AchievementsSection;
